module.exports = __webpack_public_path__ + "img/nav-right-search-below-cjdr.d59d5a79.png";